<template>
  <v-container>
    <v-chip
      v-for="(item, index) in combustiveis"
      @click="() => frentista.controle_precos && alterar_preco(item)"
      :key="index"
      color="primary"
      dark
      text-color="white"
      style="height: 50px; width: 160px;"
    >
      <svg-filler
        :path="item.icone ? require(`@/assets/combs/${item.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
        width="40px"
        height="40px"
        style="margin-left: -10px"
        :fill="item.color"
      />
      <v-layout column>
        <span class="font-weight-medium" v-if="item.item">{{ item.item.preco | currency({fractionCount:  2}) }}</span>
        <span class="font-weight-medium" v-else>A definir</span>
        <span class="caption text-truncate" style="width: 70px">{{item.nome}}</span>
      </v-layout>
      <v-icon v-show="frentista.controle_precos" right>edit</v-icon>
    </v-chip>
    <v-dialog width="400px" lazy v-model="dialog">
      <v-card>
        <v-card-title class="justify-center">
          <h2>
            CADASTRAR PREÇO
          </h2>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-form lazy-validation v-model="valid" ref="form">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model.lazy="preco"
                    outline
                    label="Preço na bomba"
                    :rules="[() => preco > 0 || '']"
                    prefix="R$"
                    v-money="money"
                  ></v-text-field>
                </v-flex>
                <Pin v-if="!autenticado" :frentista="frentista" @autenticado="autenticado = true"/>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            flat
            color="green darken-1"
            :loading="loading"
            :disabled="!autenticado"
            @click="() => cadastrarOuAlterarItem()"
          >Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { VMoney } from 'v-money'

import Pin from '@/components/Pin'

export default {
  directives: { money: VMoney },
  components: { Pin },
  data () {
    return {
      dialog: false,
      show: false,
      valid: false,
      menuInicio: false,
      preco_atual: null,
      combustivel: null,
      autenticado: false,
      today: new Date(),
      preco: null,
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: false
      }
    }
  },
  watch: {
    dialog (val) {
      if (!val) {
        this.combustivel = null
        this.autenticado = false
      }
    },
    combustivel (val) {
      if (val) {
        this.preco = null
        this.dialog = true
        this.autenticado = false
      }
    }
  },
  computed: {
    frentista () {
      return this.$store.getters.frentista
    },
    combustiveis () {
      return this.$store.getters.combustiveis
    },
    posto () {
      return this.$store.getters.posto
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    cadastrarOuAlterarItem () {
      if (this.$refs.form.validate()) {
        const data = {
          id: this.combustivel.item ? this.combustivel.item.id : null,
          body: {
            combustivel: this.combustivel.id_combustivel,
            posto: this.posto.cnpj,
            categoria_referencia: 'combustivel',
            nome: this.combustivel.nome,
            tipo: 'P',
            frentista: this.frentista.id_frentista,
            preco: this.preco
          },
          method: this.combustivel.item ? 'PUT' : 'POST'
        }
        this.$store.dispatch('cadastrarOuAlterarItem', data)
          .then(() => {
            this.dialog = false
            this.preco = null
          }).catch((e) => {
            console.error(e)
            this.$emit('error', 'Erro ao inserir o preço, verifique os dados e tente novamente')
          })
      }
    },
    alterar_preco (combustivel) {
      this.combustivel = combustivel
    }
  }
}
</script>
